import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'si-mobile-optimisation-warning',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule,MatIconModule],
  templateUrl: './mobile-optimisation-warning.component.html',
})
export class MobileOptimisationWarningComponent {
  private dialogRef = inject(MatDialogRef<MobileOptimisationWarningComponent>);

  onClose(): void {
    this.dialogRef.close();
  }
}